// useJsApiLoader's loader is a singleton: every caller on a page must pass identical options,
// otherwise it throws "Loader must not be called again with different options".
export const GOOGLE_MAPS_API_KEY = "AIzaSyCeyT81jyJvv2cyj9W3uZrOt_mWNv0uPvk";
export const GOOGLE_MAPS_LIBRARIES = ["places"];
